import { render, staticRenderFns } from "./BatchSampleList.vue?vue&type=template&id=cca467c0&scoped=true"
import script from "./BatchSampleList.vue?vue&type=script&lang=js"
export * from "./BatchSampleList.vue?vue&type=script&lang=js"
import style0 from "./BatchSampleList.vue?vue&type=style&index=0&id=cca467c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca467c0",
  null
  
)

export default component.exports